<template>
  <div class="top-menu">
    <div class="top clearfix">
      <div class="l" :class="{ 'min':  isCollapse }">
        <div class="login-box">
          <div>
            <img src="@/assets/images/logo.png" alt class="logo"/>
          </div>
          <!-- <img class="text-logo" src="@/assets/images/logo_text.png" alt /> -->
        </div>
      </div>
      <div class="r">
        <!-- <div class="icon-box" v-if="$route.path !== '/workbench'">
          <i v-if="!isCollapse" class="el-icon-s-fold" @click="$emit('update:isCollapse', true)"></i>
          <i v-if="isCollapse" class="el-icon-s-unfold" @click="$emit('update:isCollapse', false)"></i>
        </div> -->
        <div class="tabs">
          <div class="_f">
            <div
              v-for="(item, idx) in allRouter"
              :key="idx"
              v-if="item.name && item.name !='login' && isHasRouter(item)"
              class="tabs-li"
              :class="{'active': currentRouter.meta && currentRouter.meta.menuKey == item.name}"
              @click="goRouter(item)"
            >
              <p>
                <i v-if="item.meta && item.meta.menuIcon" :class="item.meta.menuIcon"></i>
                {{ item.meta.menuTitle }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-r">
        <el-popover
          placement="bottom"
          width="200"
          trigger="click">
            <ul class="down-wj">
              <li>
                <img src="../../assets/images/newIcon/folder_icon.png" alt="">
                <div class="d">
                  <p>用户列表.xlsx</p>
                  <p><el-progress :percentage="50"></el-progress></p>
                </div>
              </li>
              <li>
                <img src="../../assets/images/newIcon/folder_icon.png" alt="">
                <div class="d">
                  <p>用户列表.xlsx</p>
                  <p style="color:#999;">110kb</p>
                </div>
              </li>
              <li>
                <img src="../../assets/images/newIcon/folder_icon.png" alt="">
                <div class="d">
                  <p>用户列表.xlsx</p>
                  <p><el-progress :percentage="50"></el-progress></p>
                </div>
              </li>
            </ul>
            <el-badge slot="reference" is-dot class="item down-d">
               <img  style="margin-right:30px;vertical-align: middle;width: 24px;" src="../../assets/images/newIcon/download_icon.png" alt="">
            </el-badge>
          
        </el-popover>
        <el-dropdown size="medium">
          <span class="el-dropdown-link">
            <p class="inline">
              <!-- <el-button
                style="height: 24px;"
                class="inline"
                type="primary"
                icon="el-icon-user"
                circle
              ></el-button> -->
            </p>
            <!-- {{loginData ? loginData.name : ''}} -->
            <!-- <i class="inline el-icon-caret-bottom el-icon--right"></i> -->
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item icon="el-icon-s-tools" @click.native="modifyPassword">修改密码</el-dropdown-item> -->
            <!-- <el-dropdown-item icon="el-icon-back" @click.native="signOut">退出</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="medium">
          <span class="el-dropdown-link">
            <p class="inline">
              <el-button
                style="height: 24px;"
                class="inline"
                type="primary"
                icon="el-icon-user"
                circle
              ></el-button>
            </p>
             {{loginData ? loginData.name : ''}}
            <i class="inline el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item icon="el-icon-s-tools" @click.native="modifyPassword">修改密码</el-dropdown-item> -->
            <el-dropdown-item icon="el-icon-back" @click.native="signOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div style="height: 56px;"></div>
    <el-dialog
      title="修改密码"
      width="540px"
      :close-on-click-modal="false"
      custom-class="edit-dialog"
      :visible.sync="editDialog"
    >
      <el-form
        :model="editObj"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        style="text-align: center;margin-bottom: 20px;"
      >
        <el-form-item label="新密码" prop="password">
          <el-input v-model="editObj.password" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="editObj.confirmPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editData">确 定</el-button>
        <el-button @click="editDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import { loginOut } from "@/api/common";
import { mapMutations, mapActions } from "vuex";
// import { putAdminUser } from "@/api/auth";
import Utils from "@/jslibs/utils";
import jurisdictionMenu from "@/mixins/jurisdictionMenu";
export default {
  name: "topMenu",
  props: ["isCollapse"],
  mixins: [jurisdictionMenu],
  data() {
    return {
      editDialog: false,
      editObj: {
        password: "",
        confirmPassword: ""
      },
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        confirmPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.editObj.password !== value) {
                callback(new Error("两次密码不一致"));
                return false;
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["loginData"]),
    allRouter() {
      // console.log(this.$router.options.routes,"tops")
      return this.$router.options.routes;
    },
    currentRouter() {
      return this.$route;
    },
    currentRouterMeta() {
      return this.currentRouter.meta || {};
    }
  },
  methods: {
    ...mapMutations(["updateLoginData"]),
    validatePass(rule, value, callback) {
      if (value != this.editObj.password) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    },
    signOut() {
      this.$confirm("是否继续退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        this.updateLoginData("");
        Utils.setCookie("X-Access-Token", "", new Date(0));
        Utils.setCookie("adminName", "", new Date(0));
        this.$router.push({ name: "login" });
        // let data = {
        //   account: this.loginData.userinfo.account,
        //   password: this.loginData.userinfo.password
        // };
        // loginOut(data).then(({ code, data }) => {
        //   if (code == 200) {
        //     this.updateLoginData("");
        //     Utils.setCookie("X-Access-Token", "", new Date(0));
        //     Utils.setCookie("adminName", "", new Date(0));
        //     this.$router.push({ name: "login" });
        //   }
        // });
      })
      .catch(() => {});
    },
    modifyPassword() {
      this.editDialog = true;
    },
    editData() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let data = {
            account: this.loginData.userinfo.account,
            mobile: this.loginData.userinfo.mobile,
            name: this.loginData.userinfo.name,
            role_id: this.loginData.userinfo.role_id,
            id: this.loginData.userinfo.id,
            password: this.editObj.password
          };
          putAdminUser(data).then(({ code }) => {
            if (code == 200) {
              this.$message({
                message: `修改密码成功`,
                type: "success"
              });
              this.updateLoginData("");
              Utils.setCookie("X-Access-Token", "", new Date(0));
              Utils.setCookie("adminName", "", new Date(0));
              this.$router.push({ name: "login" });
              this.editDialog = false;
            }
          });
        }
      });
    },
    goRouter(item) {
        if (item.name == 'workbench') {
          this.$router.push({
            name: item.name
          });
          return false
        }
        let goRouterObj = item.children.filter(e => !e.meta.secondMenuKey && this.isHasRouter(e))[0]
        this.$router.push({
          name: goRouterObj.name
        });
    },
    isHasRouter(item) {
      return true
      // return item.name == 'workbench'|| this.jurisdictionMenu.filter((e) => item.name == e.name).length;
    },
  },
  created(){
    // if (!this.loginData || !this.loginData.userinfo || !this.loginData.userinfo.id) {
    //   this.$router.push({ name: "login" });
    // }
  }
};
</script>
<style>
   @media screen and (min-width: 1200px) and (max-width: 1366px){
    .top-menu .top .r .tabs .tabs-li {
      margin-right: 10px !important;
    }
  }
</style>
<style lang="less" scoped>
 
.down-wj{
    li{
      display: flex;
      justify-content: space-between;
      margin-bottom:15px;
      img{
        width:32px;
        height:32px;
      }
      .d{
        width:150px;
        // display: inline-block;
      }
    }
  }
  .down-d{
    /deep/ .el-badge__content{
        right: 36px;
        top: 22px;
    }
  }
.top-menu {
  position: relative;
  /deep/ .el-dropdown{
    color:#fff;
  }
  
  .top {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    box-sizing: border-box;
    background: linear-gradient(146deg, #327EFF 0%, #327EFF 100%);
    box-shadow: 4px 0px 6px 0px rgba(0, 19, 38, 0.06);
    height: 58px;
    display: flex;
    .l {
      width: 262px;
      transition: 0.5s all;
      overflow: hidden;
      &.min {
        width: 63px;
        .login-box {
          margin-left: 5px;
        }
      }
    }
    .r {
      flex: 1;
      line-height: 56px;
      font-size: 16px;
      color: #fff;
      .icon-box {
        display: inline-block;
        padding: 0 30px 0 26px;
      }
      i {
        cursor: pointer;
      }
      .tabs {
        display: inline-block;
        font-size: 14px;
        text-align: center;
        width: calc(100% - 30px);
        ._f {
          display: flex;
        }
        .tabs-li {
          padding:0 10px;
          min-width: 110px;
          margin-right:30px;
          box-sizing: border-box;
          cursor: pointer;
          display: inline-block;
          // flex: 1;
          i {
            margin-right: 10px;
          }
          &.active {
            // padding: 0 10px;
            color: #fff;
            height: 53px;
            border-bottom: 3px solid #fff;
          }
        }
      }
    }
    .login-box {
      // transition: 0.5s all;
      // line-height: 22px;
      // height: 22px;
      // display: inline-block;
      // padding-left: 60px;
      margin-top: 10px;
      margin-left: 60px;
      // position: relative;
      // > div {
      //   width: 48px;
      //   height: 48px;
      //   border-radius: 2px;
      //   overflow: hidden;
      //   position: absolute;
      //   margin-top: -13px;
      //   left: 0;
      //   > img {
      //     width: 100%;
      //     height: 100%;
      //   }
      // }
      // img {
      //   height: 22px;
      // }
    }
    > .menu-r {
      width: 240px;
      line-height: 56px;
      > i {
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        margin-right: 19px;
        position: relative;
        &.hasnews {
          &:after {
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            background: #fa5271;
            border-radius: 3px;
            position: absolute;
            top: -2px;
            right: 0px;
          }
        }
      }
      .inline {
        font-size: 12px;
        color: #409EFF;
        cursor: pointer;
        .el-button {
          padding: 5px;
          margin-top: -4px;
          background: #fff;
        }
        &:hover {
          color: #0099ff;
        }
        i {
          font-size: 19px;
          margin-top: -3px;
        }
      }
    }
  }
}
.logo {
  width: 120px;
  // height: 28px;
}
</style>
